import React from 'react'
import { P } from 'styled-system-html'

export default props => (
  <P mb={1} {...props}>
    {props.children}
  </P>
)
